/**
 * IDG Insights Email Settings Overlay
 * Wrapper for the IDG Insights Email Settings as a sheet overlay
 */

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import IDGInsightsEmailSettings from "@/components/IDGInsightsEmailSettings";
import { Mail } from "lucide-react";

export default function IDGInsightsEmailOverlay({ isOpen, onClose }) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent 
        side="right" 
        className="w-[700px] sm:max-w-[700px] bg-slate-900 border-slate-700 overflow-y-auto"
      >
        <SheetHeader className="mb-4">
          <SheetTitle className="text-white flex items-center gap-2">
            <Mail className="w-5 h-5 text-teal-400" />
            IDG Insights Email Settings
          </SheetTitle>
        </SheetHeader>
        <IDGInsightsEmailSettings onClose={onClose} />
      </SheetContent>
    </Sheet>
  );
}
